import { render, staticRenderFns } from "./RegisterCompleted.vue?vue&type=template&id=c3f0d344&scoped=true"
import script from "./RegisterCompleted.vue?vue&type=script&lang=js"
export * from "./RegisterCompleted.vue?vue&type=script&lang=js"
import style0 from "./RegisterCompleted.vue?vue&type=style&index=0&id=c3f0d344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f0d344",
  null
  
)

export default component.exports